export interface IReferenceValueForRatioCalculation {
    openingReferenceValue: number;
    closingReferenceValue: number;
}
